import React, { useEffect, useState } from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as LearnerIcon } from "../../../images/learnersimage/learnericon.svg";
import useStyles from "../../../../styles";
import LearnerDetails from "../../../CustomComponent/LearnerDetails";
import AssignViewLearner from "./ViewAssignLearner";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@material-ui/core";

function AssignLearner() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <LearnerIcon />,
      mainheading: "Assign Learner",
    },
  ];
  let { selectedCource1, selectedBatch1, selectedCenter1 } = useParams();

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [learners, setLearners] = useState([]);
  const navigate = useNavigate();

  const [pageNumber, setPageNumber] = useState(0);
  const [size, setSize] = useState(25);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState("");

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setPageNumber(newPage); // Pass newSelection directly
  };

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner/all/filter/center?course_id=${selectedCource1}&batch_id=${selectedBatch1}&center_id=${selectedCenter1}&page=${
          pageNumber + 1
        }&limit=${size}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      setLearners(response.data.learners);
      setRowCount(response.data.count);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedCource1, selectedBatch1, selectedCenter1, decryptedToken, pageNumber]);

  const fetchDataWithoutFilters = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner/not/assigned`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      setLearners(response.data.learners);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchDataWithoutFilters();
  }, []);

  const rows = learners.map((d) => ({
    id: d?.id ? d.id : "N/A",
    full_name: d?.full_name ? d.full_name : "N/A",
    roll_no: d?.learner_information?.roll_number
      ? d.learner_information.roll_number
      : "N/A",
    phone: d?.phone ? d.phone : "N/A",
    email: d?.email ? d.email : "N/A",
    course_name: d?.learner_information?.course?.course_name
      ? d.learner_information.course.course_name
      : "N/A",
    center_code:
      d.learner_information && d.learner_information.center
        ? `${d.learner_information.center.center_code || "N/A"} - ${d.learner_information.center.center_name || "N/A"}`
        : "N/A",
    batch_name: d?.learner_information?.batch?.batch_name
      ? d.learner_information.batch.batch_name
      : "N/A",
    guardian_name: d?.learner_information?.guardian_name
      ? d.learner_information.guardian_name
      : "N/A",
    created_at: d?.created_at ? d?.created_at : "N/A",
    active_status: d?.active_status ? d?.active_status : "N/A",
  }));

  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch = d.full_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: index + 1,
    }));

  const columns = [
    {
      field: "roll_no",
      headerName: "Roll No.",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "full_name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "phone",
      headerName: "Ph.No.",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "course_name",
      headerName: "Course",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      type: "number",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "batch_name",
      headerName: "Batch",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      type: "number",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_code",
      headerName: "Branch Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      type: "number",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
  ];

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");

  const [cources, setCources] = useState([]);
  const [selectedCource, setSelectedCource] = useState("");

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

  const fetchCenter = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/filter/all`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        setCenter(data.centers);
      } else {
        console.error("Failed to fetch center data");
      }
    } catch (error) {
      console.error("Error fetching center data:", error);
    }
  };

  useEffect(() => {
    fetchCenter();
  }, []);

  const handleCenterChange = (event, newValue) => {
    setSelectedCenter(newValue ? newValue.id : null);
    setSelectedCource(null);
    setSelectedBatch(null);
    setCources([]);
    setBatches([]);
  };

  const fetchCources = async (selectedCenter) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centerid/${selectedCenter}`,

        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        setCources(data.center.courses);
      } else {
        console.error("Failed to fetch batches data");
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchCources(selectedCenter);
  }, [selectedCenter]);

  const handleCourceChange = (event, newValue) => {
    setSelectedCource(newValue ? newValue.id : null);
    setSelectedBatch(null);
    setBatches([]);
  };

  const fetchBatches = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      // Ensure selectedCourses is not empty before making the request
      if (selectedCenter && selectedCource) {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              center: {
                centerId: selectedCenter,
                courseId: selectedCource,
              },
            }),
          },
        );
        if (response.ok) {
          const data = await response.json();
          setBatches(data.center.batches);
        } else {
          console.error("Failed to fetch batches data:", response);
        }
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchBatches();
  }, [selectedCenter, selectedCource]);

  const handleBatchChange = (event, newValue) => {
    setSelectedBatch(newValue ? newValue.id : null);
  };

  let [Id, setId] = useState("");

  const handleCheckboxClick = (selectedIDs) => {
    setId(selectedIDs);
  };

  const handleStatus = async () => {
    // Validation checks
    if (!Id || Id.length === 0) {
      toast.error("Please select at least one learner.");
      return;
    }
    if (!selectedCenter) {
      toast.error("Please select a center.");
      return;
    }
    if (!selectedCource) {
      toast.error("Please select a course.");
      return;
    }
    if (!selectedBatch) {
      toast.error("Please select a batch.");
      return;
    }

    try {
      const data = {
        learner: {
          ids: Id,
          course_id: selectedCource,
          batch_id: selectedBatch,
          center_id: selectedCenter,
        },
      };

      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner/assign/center`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      fetchData();
      toast.success("Learner assigned successfully");
      handleClose();

      setTimeout(() => {
        navigate(`/admin/learner`);
      }, 2000);
    } catch (error) {
      console.error("Error changed Learner status:", error);
      toast.error("Learner is not assigned ", error);
    }
  };

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <PageHeader Heading={Heading} />
      <LearnerDetails />

      <div
        className={`${classes.w100} ${classes.h49vh} ${classes.bgwhite} ${classes.borderradius6px}`}
      >
        <AssignViewLearner
          menuProps={menuProps}
          columns={columns}
          filteredRows={filteredRows}
          handleStatus={handleStatus}
          center={center}
          selectedCenter={selectedCenter}
          handleCenterChange={handleCenterChange}
          cources={cources}
          selectedCource={selectedCource}
          handleCourceChange={handleCourceChange}
          batches={batches}
          selectedBatch={selectedBatch}
          handleBatchChange={handleBatchChange}
          handleCheckboxClick={handleCheckboxClick}
          setPageSize={setSize}
          pageSize={size}
          rowCount={rowCount}
          handlePageChange={handlePageChange}
          page={page}
          paginationMode="server"
        />
        <div
          className={`${classes.w100} ${classes.dflex} ${classes.justifyflexend}`}
        >
          <Button
            variant="contained"
            color="primary"
            className={`${classes.bluebtn} ${classes.my0_5}`}
            onClick={handleStatus}
          >
            Save & Assign
          </Button>
        </div>
      </div>
    </div>
  );
}
export default AssignLearner;
